import React from 'react';
import { Section, FadeIn, Button } from './ui';
import { BarChart3Icon, TrendingUpIcon, Users2Icon, TargetIcon, ActivityIcon, MessageSquareIcon } from 'lucide-react';
export function Reporting() {
  return <Section id="reports" className="bg-slate-50 overflow-hidden" data-id="element-6545">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-6546">
        {/* Left: Copy */}
        <div data-id="element-6547">
          <FadeIn data-id="element-6548">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-6549">
              Show the client what actually happened.
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-6550">
              Offsite+ turns event activity into a clean post-event report with
              engagement, preferences, feedback, themes, and commitments.
            </p>
            <Button variant="primary" size="lg" href="/report" data-id="element-6551">
              See Sample Report
            </Button>
          </FadeIn>
        </div>

        {/* Right: Mock Report Dashboard */}
        <FadeIn delay={0.2} className="relative" data-id="element-6552">
          <div className="absolute inset-0 bg-brand-navy/5 rounded-full blur-3xl" data-id="element-6553" />

          <div className="relative bg-white rounded-2xl shadow-soft border border-slate-100 p-6 md:p-8" data-id="element-6554">
            <div className="flex items-center justify-between mb-8" data-id="element-6555">
              <h3 className="font-bold text-xl text-brand-navy" data-id="element-6556">
                Post-Event Report
              </h3>
              <span className="bg-brand-teal/10 text-brand-teal text-xs font-bold px-3 py-1 rounded-full" data-id="element-6557">
                Final
              </span>
            </div>

            {/* Top Stats */}
            <div className="grid grid-cols-3 gap-4 mb-8" data-id="element-6558">
              <div className="bg-slate-50 p-4 rounded-xl text-center" data-id="element-6559">
                <div className="text-2xl font-black text-brand-navy mb-1" data-id="element-6560">
                  92%
                </div>
                <div className="text-xs text-slate-500 font-medium uppercase tracking-wider" data-id="element-6561">
                  Intake
                </div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl text-center" data-id="element-6562">
                <div className="text-2xl font-black text-brand-teal mb-1" data-id="element-6563">
                  78%
                </div>
                <div className="text-xs text-slate-500 font-medium uppercase tracking-wider" data-id="element-6564">
                  Intros
                </div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl text-center" data-id="element-6565">
                <div className="text-2xl font-black text-brand-coral mb-1" data-id="element-6566">
                  64%
                </div>
                <div className="text-xs text-slate-500 font-medium uppercase tracking-wider" data-id="element-6567">
                  Wellness
                </div>
              </div>
            </div>

            {/* Connection Score */}
            <div className="bg-brand-navy text-white p-5 rounded-xl mb-6 flex items-center justify-between" data-id="element-6568">
              <div className="flex items-center gap-3" data-id="element-6569">
                <TrendingUpIcon className="w-8 h-8 text-brand-teal" data-id="element-6570" />
                <div data-id="element-6571">
                  <div className="text-sm text-slate-300" data-id="element-6572">Connection Score</div>
                  <div className="font-bold" data-id="element-6573">Improved +1.7</div>
                </div>
              </div>
              <div className="flex items-center gap-2 font-mono text-xl" data-id="element-6574">
                <span className="text-slate-400" data-id="element-6575">6.4</span>
                <span className="text-brand-teal" data-id="element-6576">→</span>
                <span className="font-bold" data-id="element-6577">8.1</span>
              </div>
            </div>

            {/* Bottom Grid */}
            <div className="grid grid-cols-2 gap-4" data-id="element-6578">
              <div className="border border-slate-100 rounded-xl p-4" data-id="element-6579">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-3" data-id="element-6580">
                  <TargetIcon className="w-4 h-4 text-brand-coral" data-id="element-6581" /> Top Goals
                </div>
                <div className="flex flex-wrap gap-1.5" data-id="element-6582">
                  {['Alignment', 'Communication', 'Energy', 'Trust'].map(g => <span key={g} className="bg-slate-100 text-[10px] font-bold text-slate-600 px-2 py-1 rounded" data-id="element-6583">
                        {g}
                      </span>)}
                </div>
              </div>

              <div className="border border-slate-100 rounded-xl p-4 flex flex-col justify-center items-center text-center" data-id="element-6584">
                <MessageSquareIcon className="w-6 h-6 text-brand-teal mb-2" data-id="element-6585" />
                <div className="text-2xl font-black text-brand-navy" data-id="element-6586">43</div>
                <div className="text-xs text-slate-500 font-medium" data-id="element-6587">
                  Commitments Captured
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
}